<template>
  <login :urlLogin="urlLogin" :redirectPath="redirectPath" :img="img"></login>
</template>
<script>
export default {
  components: {
    login: () => import('@/components/login/login.vue')
  },
  data () {
    return {
      urlLogin: 'login_modelo',
      redirectPath: '/menu',
      img: 'login_spore.png'
    }
  }
}
</script>
